<template>
    <div style="display: flex;  height: 700px;">
        <div class="tim_userlist">
            <div class="itmes" :class="nowUserID == item.userProfile.userID ? 'active' : ''"
                v-for="(item, index) in userList" :key="index" @click="getToUserInfo(item)">
                <div class="items_img">
                    <el-badge :value="item.unreadCount" class="item" v-if="item.unreadCount != 0">
                        <img :src="item.userProfile.avatar" alt="" srcset="">
                    </el-badge>
                    <img :src="item.userProfile.avatar" alt="" srcset="" v-else>
                </div>
                <div class="items_cont">
                    <div class="items_top">
                        <div class="items_name">{{ item.userProfile.nick }}</div>
                        <div v-if="item.lastMessage" class="items_time">{{ item.lastMessage.lastTime | dateFormat }}
                        </div>
                    </div>
                    <div class="items_text" v-if="item.lastMessage">
                        <div v-if="item.lastMessage.isRevoke">
                            <span >[消息已被撤回]</span>
                        </div>
                        <div v-else>
                            <span v-if="datatype(item) == 'image'">[图片]</span>
                            <span v-if="datatype(item) == 'file'">[文件]</span>
                            <span v-if="datatype(item) == 'system'">[系统提示]{{item.lastMessage.payload.data }}</span>
                            <span v-if="datatype(item) == 'link_text'">[自定义消息]</span>
                            <span v-if="datatype(item) == 'default'">{{
                                item.lastMessage.payload.data }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="kongts" v-if="userList.length == ''">
                <div>
                    <img src="../../assets/tim/leftkong.png" alt="" srcset="">
                    <div class="texts">
                        暂无会话信息
                    </div>
                </div>
            </div>

        </div>
        <div class="tim_cont" v-if="isrightshow">
            <div class="tim_cont_l">
                <div class="tim_cont_top">
                    <div class="c_flex">
                        <div class="uname">{{ nowUserInfo.userProfile.nick }}</div>
                        <img v-if="ishaoyou" src="../../assets/tim/q.png" alt="" srcset=""
                            @click="handlerHaoyou(nowUserInfo.userProfile.userID, 1)">
                        <img v-else src="../../assets/tim/j.png" alt="" srcset=""
                            @click="handlerHaoyou(nowUserInfo.userProfile.userID, 2)">
                    </div>
                    <div v-if="isupload">
                        <div style="display: flex;">
                            <div v-for="(item, index) in waitFileList " :key="index">
                                <div>{{ item.fileName }}</div>
                                <el-progress style="width:150px" :text-inside="true" :stroke-width="12"
                                    :percentage="item.progress"></el-progress>
                            </div>
                        </div>
                    </div>
                    <div class="cs" @click="isopen" v-if="nowUserID != 'xj1'">
                        <i class="el-icon-more"></i>
                    </div>
                </div>
                <div class="tim_cont_c" @scroll="scrollEventSay" v-if="isrightshow">
                    <div v-for="(item, index) in wordList" :key="item.id">
                        <div class="tim_time" v-show="index == 0">
                            {{ item.time | dateFormat }}
                        </div>
                        <div v-if="index != 0" class="tim_time">
                            <span v-if="item.time - wordList[index - 1].time > 5 * 60">
                                {{ item.time | dateFormat }}
                            </span>
                        </div>

                        <div v-if="item.type == 'system'" class="tim_system">
                            <i class="el-icon-warning"></i>
                            <span>
                                {{ item.contactText }}
                            </span>
                        </div>

                        <div v-if="item.isRevoke" class="tim_revoketip">
                            <i class="el-icon-warning"></i>
                            <span v-if="item.mineMsg">
                                你撤回了一条消息
                            </span>
                            <span v-else>
                                {{nowUserInfo.userProfile.nick}} 撤回了一条消息
                            </span>
                        </div>

                        <div class="left_cont_i" v-if="item.mineMsg == false && item.type != 'system' && !item.isRevoke">
                            <img class="avatar" :src="item.avatar" alt="" srcset="">
                            <div v-if="item.type == 'default'" class="xx" style="margin-left: 10px;">
                                {{ item.contactText }}
                            </div>
                            <div v-if="item.type == 'file'" class="file xx" style="margin-left: 10px;">
                                <div class="file_flex">
                                    <div class="imgs">
                                        <img :src="FileIcon(item)" alt="">
                                    </div>
                                    <div>
                                        <div class="filename">{{ item.fileName | urlCode }}</div>
                                        <div class="filesize"> {{ item.fileSize }} </div>
                                    </div>
                                    <button class="preview-file-btn" :disabled="isPreviewFile(item)" @click="hanldePreViewFile(item)">
                                        预览文件
                                    </button>
                                    <div class="imgsd" @click="download(item)">
                                        <img src="../../assets/tim/down.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type == 'image'" style="margin-left: 10px;">
                                <el-image :preview-src-list="[item.contactText]"
                                    style="max-width: 160px;height: 100px;border-radius: 6px;"
                                    :src="item.contactText"></el-image>
                            </div>
                            <div v-if="item.type == 'link_text'"  v-html="item.contactText" class="xx" style="margin-left: 10px;">

                            </div>
                        </div>

                        <div class="right_cont_i" v-if="item.mineMsg && item.type != 'system' && !item.isRevoke">
                            <div class="rig">
                                <img class="avatar" :src="item.avatar" alt="" srcset="">
                                <div v-if="item.type == 'default'" class="xx" style="margin-right: 10px;">
                                    {{ item.contactText }}
                                    <div class="isread" :class="item.read ? '' : 'cobule'">
                                        {{ item.read ? "已读" : "未读" }}
                                    </div>
                                    <span v-if="item.showRecall" 
                                        @click="handleRecall(item.id)"
                                        class="recall-btn">
                                        撤回
                                    </span>
                                </div>
                                <div v-if="item.type == 'file'" class="file xx" style="margin-right: 10px;">
                                    <div class="file_flex">
                                        <div class="imgs">
                                            <img :src="FileIcon(item)" alt="">
                                        </div>
                                        <div>
                                            <div class="filename">{{ item.fileName | urlCode }}</div>
                                            <div class="filesize"> {{ item.fileSize }} </div>
                                        </div>
                                        <button class="preview-file-btn" :disabled="isPreviewFile(item)" @click="hanldePreViewFile(item)">
                                            预览文件
                                        </button>
                                        <span v-if="item.showRecall" 
                                            @click="handleRecall(item.id)"
                                            class="recall-btn">
                                            撤回
                                        </span>
                                    </div>
                                    <div class="isread" :class="item.read ? '' : 'cobule'">
                                        {{ item.read ? "已读" : "未读" }}
                                    </div>
                                </div>

                                <div v-if="item.type == 'image'" class="img" style="margin-right: 10px;">
                                    <el-image :preview-src-list="[item.contactText]"
                                        style="max-width: 160px;height: 100px;border-radius: 6px;"
                                        :src="item.contactText"></el-image>
                                    <div class="isread" :class="item.read ? '' : 'cobule'">
                                        {{ item.read ? "已读" : "未读" }}
                                    </div>
                                    <span v-if="item.showRecall" 
                                        @click="handleRecall(item.id)"
                                        class="recall-btn">
                                        撤回
                                    </span>
                                </div>
                                <div v-if="item.type == 'link_text'" class="xx">
                                    <div  v-html="item.contactText"  style="margin-right: 10px;">
                                    </div>
                                    <span v-if="item.showRecall" 
                                        @click="handleRecall(item.id)"
                                        class="recall-btn">
                                        撤回
                                    </span>
                                    <div class="isread" :class="item.read ? '' : 'cobule'">
                                        {{ item.read ? "已读" : "未读" }}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_bot">
                    <div class="send_flex">
                        <div class="flex_l">
                            <div class="its" @click="getFile">
                                <div style="height: 29px;display:flex; align-items: center;"><img
                                        src="../../assets/tim/t4.png" alt="" srcset="">上传文件</div>
                                <input type="file" multiple ref="file" style="display: none;"
                                    v-on:change="handleDrop($event)">
                            </div>
                          
                            <!-- <el-popover v-model="isbaoji" placement="top-start" trigger="click"
                                v-if="nowUserID != 'xj1'">
                                <div class="fktx">
                                    <div>点击报价提醒，向供应商发送报价提醒</div>
                                    <div class="btn" @click="opent(4)">发送提醒</div>
                                </div>
                                <div slot="reference" class="its">
                                    <img src="../../assets/tim/t6.png" alt="" srcset="">
                                    提醒客服
                                </div>
                            </el-popover> -->

                            <div class="its" @click="opent(4)" v-if="nowUserID != 'xj1'">
                                <img src="../../assets/tim/t6.png" alt="" srcset="">
                                提醒客服
                            </div>

                            <el-popover v-model="isfhuo" placement="top" trigger="click" v-if="nowUserID != 'xj1'">
                                <div class="flist" v-infinite-scroll="load" infinite-scroll-immediate="false">
                                    <div class="item" v-for="(item, index) in orderlist" :key="index">
                                        <div class="iteml">
                                            <img src="@/assets/order.png" alt="" srcset="">
                                            <div>
                                                <div>订单号：{{ item.order_no }}</div>
                                                <div>金额：￥{{ item.order_money }}</div>
                                            </div>
                                        </div>
                                        <div class="itemr" @click="opent(2, item)">
                                            确认发送
                                        </div>
                                    </div>
                                    <div class="ok" v-if="orderlist.length == 0">
                                        <div>
                                            <img src="@/assets/user/k.png" alt="" srcset="">
                                            <div class="text">暂无订单</div>
                                        </div>
                                    </div>
                                </div>

                                <div slot="reference" class="its">
                                    <img src="../../assets/tim/t5.png" alt="" srcset="">
                                    发货提醒
                                </div>
                            </el-popover>

                            <el-popover v-model="isKehu" placement="top-start" trigger="manual" v-if="nowUserID != 'xj1'">
                            <div class="khxx">
                                <!-- 关闭按钮 -->
                                <button class="khxx-close-btn" @click="isKehu = false">×</button>
                                <!-- 数据加载完成后的内容 -->
                                <template v-if="kehuData">
                                    <div class="khxx-item">
                                    <img class="khxx-icon" src="../../assets/top2.png" alt="图标" />
                                    {{ kehuData.nickname || "未知" }}
                                    </div>
                                    <div class="khxx-item">
                                    <img class="khxx-icon" src="../../assets/imgleft/i3.png" alt="图标" />
                                    电话：{{ kehuData.contract_mobile || "无" }}
                                    </div>
                                    <!-- <div class="khxx-item">
                                    <img class="khxx-icon" src="../../assets/dw.png" alt="图标" />
                                    地址：{{ kehuData.address || "未知" }}
                                    </div> -->
                                </template>
                            </div>

                            <div slot="reference" class="its" @click="fetchKehuData">
                                <img src="../../assets/top2.png" alt="">
                                联系电话
                            </div>
                        </el-popover>

                        </div>
                        <div class="btns" @click="gokf" v-if="nowUserID != 'xj1'">
                            投诉
                        </div>
                    </div>

                    <el-input v-model="message" class="no_bor" placeholder="请输入消息" @drop.native="handleDrop"
                        @paste.native.capture="handleDrop" @input="textareaInput" @keydown.native="Keydown($event)"
                        ref="message" type="textarea"></el-input>
                    <div class="btn" @click="sendmessage(1)">
                        发送
                    </div>
                </div>
            </div>
            <div class="tim_cont_r" v-if="isshow">
                <div class="tit">
                    <el-date-picker size="small" :clearable="false" :editable="false" v-model="queryParams.month_date"
                        type="month" placeholder="选择月" @change="changeMonth" value-format="yyyy-MM">
                    </el-date-picker>
                </div>
                <div v-if="orderlist.length != 0">
                    <div class="orderlist" v-infinite-scroll="load" infinite-scroll-immediate="false">
                        <div class="items" v-for="(item, index) in orderlist" :key="index">
                            <div class="itime">{{ item.createtime | formatDate }}</div>
                            <div class="item_flex">
                                <img src="@/assets/user/u1.png" alt="" srcset="">
                                <div class="uflex">
                                    <div class="cflex">
                                        <div class="r1">
                                            <div v-if="item.order_status == 1 && item.refund_status == 1">订单待支付</div>
                                            <div v-else-if="item.order_status == 2">订单待确认</div>
                                            <div v-else-if="item.order_status == 3">订单处理中</div>
                                            <div v-else-if="item.order_status == 4">订单已生效</div>
                                            <div v-else-if="item.order_status == 5 && item.refund_status == 1">已取消</div>
                                            <div v-else-if="item.order_status != 0 && item.refund_status == 2">退款中</div>
                                            <div v-else-if="item.order_status != 0 && item.refund_status == 3">已退款</div>
                                        </div>
                                        <div>￥{{ item.order_money }}</div>
                                    </div>
                                    <div class="r2">订单编号：{{ item.order_no }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="k" v-if="nolist">
                    <div>
                        <img src="@/assets/user/k.png" alt="" srcset="">
                        <div class="text">暂无订单</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kongts1" v-else>
            <div>
                <img src="../../assets/tim/rightkong.png" alt="" srcset="">
                <div class="texts">
                    暂无信息
                </div>
            </div>
        </div>
        <div class="pop" v-if="isfile">
            <div class="popflex">
                <div class="u">发送给：</div>
                <i class="el-icon-close" @click="closePop"></i>
            </div>
            <div class="popflex1">
                <div class="uimg">
                    <img :src="nowUserInfo.userProfile.avatar" alt="">
                </div>
                <div class="uname">{{ nowUserInfo.userProfile.nick }}</div>
            </div>

            <div class="filelist">
                <div class="fitem" v-for="(item, index) in waitFileList" :key="index">
                    <div class="fflex">
                        <div class="fimg" v-if="item.isimg">
                            <el-image fit="cover" lazy class="img" :src="item.fileUrl" alt="" srcset=""> </el-image>
                        </div>
                        <div class="fimg1" v-else>
                            <el-image fit="cover" lazy class="img" :src="item.fileUrl" alt="" srcset=""> </el-image>
                        </div>
                        <div class="fcont">
                            <div class="f1">

                                <div class="warp" v-if="item.filehz[0].length > 20">
                                    <div class="content">
                                        {{ item.filehz[0] }}
                                    </div>
                                    <div class="overflow" :data="item.filehz[0]">
                                        {{ item.filehz[0] }}
                                    </div>
                                </div>
                                <div v-else>
                                    {{ item.filehz[0] }}
                                </div>
                                <div>.{{ item.filehz[1] }}</div>
                            </div>

                            <div class="f2">{{ item.fileSize }}</div>
                        </div>
                    </div>
                    <div>
                        <i class="el-icon-delete" @click="handleDelete(index)"></i>
                    </div>
                </div>
            </div>

            <div class="btns">
                <div class="btn1" @click="closePop">取消</div>
                <div class="btn2" @click="uploadOss">发送 ({{ waitFileList.length }})</div>
            </div>
        </div>
        <FilePreviewDialog 
        :visible.sync="previewVisible"
        :url="previewUrl" 
        :fileName="previewFileName"
        />
    </div>
</template>

<script>
import { getUserOrderList, jhaoyou, shaoyou,getUserDesc } from '@/api/index'
import { createSession, sendmesg, judgeSendMsg } from '@/api/txim'
import { mapState } from 'vuex'
import { uploadOssMultipart } from '@/utils/uploadOss.js';
import { saveAs } from 'file-saver';

import FilePreviewDialog from '../MultiFilePreView/MultiFilePreView.vue';

export default {
    components: { FilePreviewDialog },
    props: {
        nowlist: {
            type: Array
        },
        toUserInfo: {
            type: Object
        }
    },
    name: '',
    data() {
        return {
            userList: [],
            nowUserID: '',//当前要发送消息的人的id

            nowUserInfo: {}, //当前要发送消息的人回话信息
            message: '',
            wordList: [],
            isshow: false,

            ishaoyou: false,
            isrightshow: false,

            isCompleted: true,
            concatShow: true,
            nextReqMessageID: '',
            scrollHeight: 0,

            fileType: ["doc", "docx", "xls", "ppt",
                "txt", "pdf", 'png',
                'jpg', 'jpeg', 'zip',
                'psd', 'xlsx', 'dwg', 'ai', 'cdr', 'tiff', 'eps', 'tif', 'mp3', 'MP3', 'MP4', 'mp4','rar'],
            waitFileList: [],
            isfile: false,
            //文件上传
            limit: 2,
            imgtype: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'image', 'webp'],
            file: null,
            progress: 0,
            isupload: false,
            orderlist: [],
            queryParams: {
                page: 1,
                limit: 10,
                month_date: '',
                supplier_user_id: '',
                status: ''
            },
            nolist: false,
            Timid: '', //发给后端的会话id

            isfhuo: false, //
            isbaoji: false,
            isKehu :false,

            kehuData:null,

            noticTtype: 1,
            previewUrl: '',
            previewFileName: '',
            previewVisible:false,
            recallDuration: 600, // 撤回时间限制2分钟（120秒）
            recallCheckInterval: 1000,
            activeRecallMessages: new Set(), // 存储需要检查的消息ID
            recallTimer: null,

        }
    },
    beforeDestroy() {
        this.nowUserID = ''
        this.isrightshow = false
        if (this.recallTimer) {
            clearInterval(this.recallTimer)
        }
    },
    watch: {
        nowUserID(newVal) {
        },
        isfhuo(newVal) {
            this.orderlist = []
            this.queryParams.page = 1
            this.queryParams.status = 2
            this.queryParams.month_date = ''
            this.queryParams.supplier_user_id = this.nowUserID.substring(2)
            this.getlist()
        },
        nowlist: {
            handler(newVal, oldVal) {
                //监听info对象变化
                if (newVal) {
                    this.userList = newVal
                }
            },
        },
        toUserInfo: {
            handler(newVal, oldVal) {
                //监听info对象变化
                if (newVal.userProfile) {
                    this.getToUserInfo(newVal)
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState(['userinfo']),
        datatype() {
            return (item) => {
                if (item.lastMessage) {
                    if(item.lastMessage.isRevoke)
                    {
                        return 'default'
                    }
                    let type = JSON.parse(item.lastMessage.payload.extension).dataType
                    return type
                } else {
                    return ''
                }
            }
        }
    },
    mounted() {
        this.monitor()
        this.initRecallCheck();
    },
    methods: {

        initRecallCheck() {
            this.recallTimer = setInterval(() => {
                const now = Date.now() / 1000;
                // 只遍历需要检查的消息
                this.activeRecallMessages.forEach(id => {
                    const msg = this.wordList.find(m => m.id === id);
                    if (!msg) {
                        this.activeRecallMessages.delete(id);
                        return;
                    }
                    
                    // 计算剩余时间
                    const shouldShow = this.canRecall(msg.time)
                    if (msg.showRecall !== shouldShow) {
                        msg.showRecall = shouldShow;
                        // 如果变成不可撤回，移出检查队列
                        if (!shouldShow) {
                            this.activeRecallMessages.delete(id);
                        }
                    }
                });
            }, this.recallCheckInterval);
        },
        //跳转客服
        gokf() {
            let that = this
            that.nowUserID = 'xj1'
            that.tim.getUserProfile({
                userIDList: ['xj1'] // 请注意：即使只拉取一个用户的资料，也需要用数组类型，例如：userIDList: ['user1']
            }).then(res => {
                if (res.code == 0 && res.data.length != 0) {
                    let nowpro = {
                        userProfile: res.data[0]
                    }
                    that.nowUserInfo = nowpro
                    that.isrightshow = true
                    that.isFriend(nowpro.userProfile.userID)
                    that.scrollEvent()
                    that.concatShow = true
                    that.getSayList({ conversationID: `C2C${nowpro.userProfile.userID}`, count: 15 })
                    that.tim.setMessageRead({ conversationID: `C2C${that.nowUserID}` })
                }

            })
        },
        //默认年月日
        getGurrentTime() {
            let yy = new Date().getFullYear();
            let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
            return yy + '-' + mm
        },
        //日期切换
        changeMonth(e) {
            this.queryParams.month_date = e
            this.orderlist = []
            this.queryParams.page = 1
            this.getlist()
        },
        //打开订单
        isopen() {
            this.isshow = !this.isshow
            if (this.isshow) {
                this.queryParams.month_date = this.getGurrentTime()
                this.queryParams.supplier_user_id = this.nowUserID.substring(2)
                this.orderlist = []
                this.queryParams.page = 1
                this.queryParams.status = ''
                this.getlist()
            }
        },
        //订单请求
        getlist() {
            getUserOrderList(this.queryParams).then(res => {
                if (res.code == 1) {
                    this.orderlist.push(...res.data.list)
                    let total = Math.ceil(res.data.total / this.queryParams.limit);
                    this.nolist = total == 0
                }
            })
        },
        load() {
            this.queryParams.page++
            this.getlist()
        },
        getFile() {
            this.$refs.file.click()
        },
        download(item) {
            fetch(item.contactText).then(response => response.blob()).then(blob => {
                saveAs(blob, item.fileName); // 设置你想要的文件名
            }).catch(error => console.error('下载失败:', error));

        },
        getToUserInfo(item) {
            this.isshow = false
            this.nowUserID = item.userProfile.userID
            this.nowUserInfo = item
            this.isrightshow = true
            this.isFriend(item.userProfile.userID)
            this.scrollEvent()
            this.concatShow = true
            this.getSayList({ conversationID: `C2C${item.userProfile.userID}`, count: 15 })
            this.tim.setMessageRead({ conversationID: `C2C${this.nowUserID}` })
        },
        // file转 base64
        getBase64(file) {
            return new Promise((resolve, reject) => {
                ///FileReader类就是专门用来读文件的
                const reader = new FileReader()
                //开始读文件
                //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
                reader.readAsDataURL(file)
                // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
                reader.onload = () => resolve(reader.result)
                // 失败返回失败的信息
                reader.onerror = error => reject(error)
            })
        },
        // 获取文件大小
        getfileSize(val) {
            if (val === 0) return "0 B"
            var k = 1024;
            var sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
            let i = Math.floor(Math.log(val) / Math.log(k))
            return ((val / Math.pow(k, i)).toFixed(2) + "" + sizes[i])
        },
        //选中文件 复制文件 拖拽文件
        handleDrop(e) {
            if (this.isfile) return
            let files;
            if (e.type == 'drop') {//拖拽
                e.preventDefault()
                files = e.dataTransfer.files;
            } else if (e.type == 'paste') {//复制
                files = e.clipboardData.files;
            } else if (e.type == 'change') {
                files = e.target.files
            }
            if (files.length > this.limit) {
                this.$modal.msgError(`当前限制为 ${this.limit} 个文件，请重新选择文件后再上传。`);
                this.$refs.file.value = ''
                return
            }
            for (let i = 0; i < files.length; i++) {
                if (this.fileType) {
                    const fileName = files[i].name.split('.');
                    const fileExt = fileName[fileName.length - 1];
                    const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
                    if (!isTypeOk) {
                        this.$message(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
                        return false;
                    }
                    this.beforePush(files[i])
                }
            }
        },
        //关闭弹出
        closePop() {
            this.isfile = false
            this.waitFileList = []
            this.$refs.file.value = ''
        },
        // 删除文件
        handleDelete(index) {
            this.waitFileList.splice(index, 1);
            if (this.waitFileList.length == 0) {
                this.isfile = false
                this.$refs.file.value = ''
            }
        },
        //校验通过 保存数组
        beforePush(file) {
            let obj = {
                file: file,
                fileName: file.name,
                filehz: file.name.split('.'),
                fileSize: this.getfileSize(file.size),
                fileUrl: '',
                isimg: false,
                progress: 0,
                lastModified: file.lastModified,
                lastModifiedDate: file.lastModifiedDate
            }
            const fileName = file.name.split('.');
            const fileExt = fileName[fileName.length - 1];
            const isTypeOk = this.imgtype.indexOf(fileExt) >= 0;
            if (!isTypeOk) {
                obj.fileUrl = require('../../assets/tim/fs.png')
                obj.isimg = false
            } else {
                this.getBase64(file).then(res => {
                    obj.fileUrl = res
                    obj.isimg = true
                })
            }
            this.waitFileList.push(obj)
            this.isfile = true
        },
        //上传阿里云
        async uploadOss() {
            this.waitFileList.forEach(item => {
                const options = {
                    // 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        item.progress = Number((p * 100).toFixed(0));//进度条
                    },
                    // 目前不传Content-Type 发现会出现错误，具体原因不清除
                    headers: {
                        'Content-Type': 'Content-Type(Mime-Type)'
                    },
                    partSize: 1024 * 1024 * 1,
                };
                this.isupload = true
                uploadOssMultipart(item, options).then(res => {
                    var newName = ''
                    let index = res.res.requestUrls[0].indexOf("?");
                    if (index == -1) {
                        newName = res.res.requestUrls[0]
                    } else {
                        newName = res.res.requestUrls[0].substring(0, index)
                    }
                    if (res.res.statusCode === 200) {
                        let obj = {
                            fileName: item.fileName,
                            fileSize: item.fileSize,
                            dataType: "image",
                            progress: item.progress
                        }
                        const isTypeOk = this.imgtype.indexOf(item.filehz[1]) >= 0;
                        if (!isTypeOk) { obj.dataType = "file" } else {
                            obj.dataType = "image"
                        }
                        this.createMessage({
                            data: newName,  //文字消息
                            extension: JSON.stringify(obj),
                        })
                    }

                })
            })
            this.isfile = false
        },
        //发送文件弹窗
        monitor() {
            // 监听对方发过来的消息（我这边使用的全部是自定义字段 event.data[0].payload.data全是自定义类型）
            let onMessageReceived = (event) => {
                let payload = event.data[0].payload;
                let extension = JSON.parse(event.data[0].payload.extension)
                if (event.data[0].from != this.nowUserID) return;
                let obj = {
                    mineMsg: false,
                    contactText: payload.data,
                    read: false,
                    time: event.data[0].clientTime,
                    id: event.data[0].ID,
                    avatar: event.data[0].avatar,
                    type: extension.dataType,
                    fileName: extension.fileName,
                    fileSize: extension.fileSize,
                    isRevoke: event.data[0].isRevoke,
                };
                this.wordList.push(obj);
                if (this.isrightshow && this.nowUserID != '') {
                    //这里是我处理聊天框页面的滚动，只要有最新的数据过来就滚动条滚动到最底部
                    this.scrollEvent();
                }
            };
            // 监听对方发过来的消息
            this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);
            // 监听消息的已读,如果已读回执之后会进入
            let onMessageReadByPeer = (event) => {
                if(event.From != this.nowUserID)
                {
                    return
                }
                this.wordList.forEach((item) => {
                    if (item.mineMsg) {
                        item.read = true;
                    }
                });
            };
            this.tim.on(this.TIM.EVENT.MESSAGE_READ_BY_PEER, onMessageReadByPeer);

            let onMessageRevoked = (event) => {
                const id = event.message_id
                let obj = this.wordList.find(item => { return item.id == id })
                obj.isRevoke = true
                obj.contactText = ''
                obj.type = 'default'
            }
            this.tim.on(this.TIM.EVENT.MESSAGE_REVOKED, onMessageRevoked);

        },
        //检测是否是好友
        isFriend(userID) {
            let that = this
            let promise = that.tim.checkFriend({
                userIDList: [userID],
                type: that.TIM.TYPES.SNS_CHECK_TYPE_SINGLE,
            });
            promise.then(function (imResponse) {
                const { successUserIDList, failureUserIDList } = imResponse.data;
                if (successUserIDList[0].relation == 'CheckResult_Type_AWithB') {
                    that.ishaoyou = true
                } else {
                    that.ishaoyou = false
                }
            }).catch(function (imError) {
                console.warn('checkFriend error:', imError);
            });
        },
        //获取聊天记录
        getSayList(options) {
            // 打开某个会话时，第一次拉取消息列表，注意！第一次拉取时不要传入 nextReqMessageID
            this.tim.getMessageList(options).then(res => {
                let messageList = res.data.messageList;
                if (res.code == 0) {
                    let wordList = messageList.map((item) => {
                        let extension;
                        if(item.isRevoke == false)
                        {
                            extension = JSON.parse(item.payload.extension)
                        }else{
                            extension = {
                                dataType:'default',
                                fileName:'',
                                fileSize:''
                            }
                        }

                        let obj = {
                            mineMsg: false,
                            contactText: item.payload.data,
                            read: item.isPeerRead,
                            id: item.ID,
                            time: item.clientTime,
                            avatar: item.avatar,
                            type: extension.dataType,
                            fileName:'',
                            fileSize:'',
                            isRevoke: item.isRevoke,
                            showRecall : this.canRecall(item.clientTime),
                            
                        }
                        if(item.from !== this.nowUserID){
                            obj.mineMsg = true
                            if (obj.showRecall) {
                                this.activeRecallMessages.add(item.ID);
                            }
                        }

                        if(extension.dataType == 'default') {
                            obj.contactText=item.payload.data
                            obj.read = item.isPeerRead
                            obj.id = item.ID
                            obj.time = item.clientTime
                            obj.avatar = item.avatar
                        }else if(extension.dataType == 'image') {
                            obj.contactText = item.payload.data
                            obj.read = item.isPeerRead
                            obj.id = item.ID
                            obj.time = item.clientTime
                            obj.avatar = item.avatar
                            obj.type = extension.dataType
                        }else if(extension.dataType == 'file') {
                            obj.contactText = item.payload.data
                            obj.read = item.isPeerRead
                            obj.id = item.ID
                            obj.time = item.clientTime
                            obj.avatar = item.avatar
                            obj.type = extension.dataType
                            obj.fileName = extension.fileName
                            obj.fileSize = extension.fileSize
                        }
                        return obj
                    });
                    // console.log(wordList);
                    
                    let wordListOne = wordList.filter((item) => {
                        return item;
                    });
                    //从这里往下是处理对话框滚动条的js
                    if (this.concatShow && this.nowUserID != '') {
                        this.wordList = wordListOne;
                        this.scrollEvent()
                    } else {
                        for (let i = wordListOne.length - 1; i >= 0; i--) {
                            this.wordList.unshift(wordListOne[i]);
                        }
                        this.$nextTick(() => {
                            let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                            msg.scrollTop = msg.scrollHeight - this.scrollHeight; // 滚动高度
                        });
                    }
                    //这个地方是用来处理获取上一页内容的数据
                    this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
                    this.isCompleted = res.data.isCompleted; // 表示是否已经拉完所有消息。isCompleted 为 true 时，nextReqMessageID 为 ""。
                }
            })
        },
        //添加好友
        handlerHaoyou(userID, type) {
            let that = this
            if (type == 1) {
                let promise = that.tim.deleteFriend({
                    userIDList: [userID],
                    type: that.TIM.TYPES.SNS_DELETE_TYPE_BOTH
                });
                promise.then(function (imResponse) {
                    that.ishaoyou = false
                    shaoyou({ collect_id: userID.substring(2) }).then(res => {
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });

            } else {
                let promise = that.tim.addFriend({
                    to: userID,
                    source: 'AddSource_Type_Web',
                    type: that.TIM.TYPES.SNS_ADD_TYPE_SINGLE
                });
                promise.then(function (imResponse) {
                    that.ishaoyou = true
                    jhaoyou({ collected_id: userID.substring(2) }).then(res => {
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });
            }
        },
        opent(type, item) {
            //，2=通知供应商发货, 4=通知供应商报价
            this.noticTtype = type
            if (type == 2) {
                judgeSendMsg({ recipient_id: this.nowUserID.substring(2), notice_type: type }).then(res => {
                    if (res.code == 1) {
                        let obj = {
                            fileName: '',
                            fileSize: '',
                            dataType: "system"
                        }
                        this.createMessage({
                            data:  `系统提醒：订单${item.order_no}已支付，请尽快发货`,  //文字消息
                            extension: JSON.stringify(obj),
                        })
                        this.isfhuo = false
                    } else {
                        this.isfhuo = false
                    }
                })

            } else if (type == 4) {
                judgeSendMsg({ recipient_id: this.nowUserID.substring(2), notice_type: type }).then(res => {
                    if (res.code == 1) {
                        let obj = {
                            fileName: '',
                            fileSize: '',
                            dataType: "system"
                        }
                        this.createMessage({
                            data: '系统提醒：客户有新的订单，请尽快报价!',  //文字消息
                            extension: JSON.stringify(obj),
                        })
                        this.isbaoji = false
                    } else {
                        this.isbaoji = false
                    }
                })
            }
        },
        textareaInput() {
            //下面是input中逻辑代码, content是我的变量, 改成你的即可
            const temp = this.message.replace(/\t/g, '\n');
            let isEnter = this.message.slice(-1) === '\n';
            const hasDataLine = temp.split('\n').filter(Boolean);
            // 防止第一行空行回车放行
            if (hasDataLine.length === 0) {
                isEnter = false;
            }
            this.message = `${hasDataLine.join('\n')}${isEnter ? '\n' : ''}`;
        },
        //回车发送消息
        Keydown(event) {
            if (event.keyCode == 13) {
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.sendmessage(1)
                }
            }
        },
        sendmessage(type) {
            if (type == 1) {
                let obj = {
                    fileName: '',
                    fileSize: '',
                    dataType: "default"
                }
                if (this.message == '') {
                    this.$modal.msgWarning(`不能发送空白消息`);
                    return
                }
                this.createMessage({
                    data: this.message,  //文字消息
                    extension: JSON.stringify(obj),
                })
            }
        },
        //创建消息
        createMessage(payload) {
            let message = this.tim.createCustomMessage({
                to: this.nowUserID,
                conversationType: this.TIM.TYPES.CONV_C2C,
                payload,
            });
            let promise = this.tim.sendMessage(message);
            promise.then((imResponse) => {
                this.tim.setMessageRead({ conversationID: `C2C${this.nowUserID}` });
                let payload = imResponse.data.message.payload;
                let message = imResponse.data.message;
                let extension = JSON.parse(imResponse.data.message.payload.extension)
                let obj = {
                    mineMsg: true,
                    contactText: payload.data,
                    read: false,
                    time: message.clientTime,
                    id: message.ID,
                    avatar: message.avatar,
                    type: extension.dataType,
                    fileName: extension.fileName,
                    fileSize: extension.fileSize,
                    progress: extension.progress,
                    showRecall : this.canRecall(message.clientTime),
                    isRevoke : message.isRevoke,
                };
                this.wordList.push(obj);
                if(obj.showRecall)
                {
                    this.activeRecallMessages.add(obj.id)
                }
                this.waitFileList = this.waitFileList.filter(item => { return item.progress != 100 })
                this.message = ''
                this.scrollEvent();
                //发送完消息 先判断这个人有么有会话
                //1 有 消息发给后台携带会话id
                //2 没有 创建会话 拿到id 再发给后端消息
                if (this.Timid) {
                    this.sendmesgH(this.nowUserID.substring(2), obj)
                } else {
                    let params = {
                        user_one: this.userinfo.id, //客户
                        user_two: this.nowUserID.substring(2), //供应商
                        type: 1, //类型:1=通用 ,2=客服
                    }
                    if (this.nowUserID == 'xj1') { params.type = 2 } else { params.type = 1 }
                    createSession(params).then(res => {
                        if (res.code == 1) {
                            this.Timid = res.data.ztim_session_id
                            this.sendmesgH(this.nowUserID.substring(2), obj)

                        }
                    })
                }


            }).catch(function (imError) {
                // 发送失败
                console.warn("sendMessage error:", imError);
            });
        },
        //发送消息给后端记录
        sendmesgH(toId, item) {
            let obj = {
                ztim_session_id: this.Timid,
                type: item.type,  //消息类型:default=普通,image=图片,file=文件
                message: item.contactText,
                recipient_id: toId,
                filename: item.fileName,
                filesize: item.fileSize,
                notice_type: this.noticTtype, //1=普通，2=通知供应商发货, 4=通知供应商报价
                gys_to_user:0,
            }
            sendmesg(obj).then(rep => {
                this.isbaoji = false
                this.isfhuo = false
                this.noticTtype = 1
            })
        },
        // 控制滚动条滚动到底部
        scrollEvent() {
            // 自动滚动到底部
            this.$nextTick(() => {
                let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                msg.scrollTop = msg.scrollHeight + 10
            });
        },
        // 监听滚动条的高度，滚动到顶部后拉取聊天数据
        scrollEventSay(e) {
            if (!this.nowUserID) return;
            this.scrollHeight = e.srcElement.scrollHeight;
            if (e.srcElement.scrollTop == 0 && !this.isCompleted) {
                this.concatShow = false;
                this.getSayList({
                    conversationID: `C2C${this.nowUserID}`,
                    //拉取上一页聊天数据必传nextReqMessageID，在拉取会话列表中有提到
                    nextReqMessageID: this.nextReqMessageID,
                    count: 15,
                });
            }
        },
        async fetchKehuData() {
            if (this.isKehu){
                this.isKehu = !this.isKehu
                return
            }

            if (this.kehuData && this.kehuData.userId == this.nowUserID){
                this.isKehu = true;
                return
            }

            this.kehuData = null;
            getUserDesc({userId:this.nowUserID.substring(2)}).then(res => {
                if(res.code == 1) {
                    this.kehuData = res.data
                    this.kehuData.userId = this.nowUserID
                    this.isKehu = true; // 开始加载
                }
            })
        },
        hanldePreViewFile(item){
            this.previewUrl = item.contactText
            this.previewFileName = item.fileName
            this.previewVisible = true
        },
        isPreviewFile(item){
            const parts = item.fileName.split('.')
            if (parts.length === 1) return true 
            const ext = parts.pop().toLowerCase()
            const previewTypes = [
                'txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx',
                'ppt', 'pptx', 'zip'
            ]
            return !previewTypes.includes(ext)
        },
        FileIcon(item){
            const parts = item.fileName.split('.')
            if (parts.length === 1) return require('../../assets/extlink.png')
            const ext = parts.pop().toLowerCase()
            const text = ['docx','doc','txt']
            if (text.includes(ext)){
                return require('../../assets/exttxt.png')
            }
            const audio = ['mp3', 'mp4']
            if (audio.includes(ext)){
                return require('../../assets/extadu.png')
            }
            const pdf = ['pdf']
            if (pdf.includes(ext)){
                return  require('../../assets/extpdf.png')
            }
            const excel = ['xls','xlsx','csv']
            if (excel.includes(ext)){
                return require('../../assets/extxls.png')
            }
            const rarzip = ['zip','rar','7z']
            if (rarzip.includes(ext)){
                return require('../../assets/extzip.png')
            }
            const ppt = ['ppt','pptx','psd', 'dwg', 'ai', 'cdr', 'tiff', 'eps', 'tif']
            if (ppt.includes(ext)){
                return  require('../../assets/extppt.png')
            }
            return require('../../assets/extlink.png')
        },
        canRecall(messageTime) {
            return (Date.now() / 1000) - messageTime < this.recallDuration
        },
        
        // 处理撤回操作
        handleRecall(messageId) {
            
            this.tim.revokeMessage({message_id:messageId}).then(res => {
                console.log(res)
            })
        },
    },
}
</script>
<style lang='scss' scoped>
.flist {
    width: 420px;
    height: 200px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 400px;
        height: 80px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DEDEDE;
        padding: 12px 10px;
        box-sizing: border-box;
        margin: 0 auto 6px;

        .iteml {
            display: flex;
            align-items: center;

            img {
                width: 36px;
                height: 36px;
                margin-right: 6px;
            }
        }

        .itemr {
            cursor: pointer;
            width: 100px;
            height: 36px;
            background: #2E93FF;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
        }
    }
}

.ok {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 200px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}

.fktx {
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    align-items: center;

    .btn {
        width: 94px;
        height: 34px;
        background: #FFDB0C;
        border-radius: 7px 7px 7px 7px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
        margin-left: 30px;

    }
}

.k {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 275px;
    height: 650px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}

.kongts {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 700px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}

.kongts1 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 700px;
    text-align: center;
    width: 790px;

    img {
        width: 224px;
        height: 224px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}

.tim_userlist {
    border-right: 1px solid #eee;
    width: 250px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .active {
        background-color: #eee !important;
    }

    .itmes {
        width: 230px;
        display: flex;
        margin: 14px auto;
        box-sizing: border-box;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;

        .items_img {
            width: 40px;
            height: 40px;
            border-radius: 10px;

            img {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
        }

        .items_cont {
            flex: 1;
            margin-left: 5px;
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

        }

        .items_top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .items_name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
                width: 90px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .items_time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #ADAAAA;
            }


        }

        .items_text {
            width: 140px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ADAAAA;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;

            span {
                width: 100px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .itmes:hover {
        background: #f4f4f4;
    }
}

.pop {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0%;
    margin: auto;
    width: 380px;
    height: 480px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px 10px 10px;
    padding: 23px 20px;
    box-sizing: border-box;

    .popflex {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .u {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            line-height: 19px;
        }

        i {
            font-size: 24px;
            cursor: pointer;
            color: #909399;

            &:hover {
                color: #409EFF;
            }
        }

    }

    .popflex1 {
        display: flex;
        align-items: center;
        margin: 18px auto 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        .uimg {
            img {
                width: 40px;
                height: 40px;
                border-radius: 20px;
            }
        }

        .uname {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            margin-left: 10px;
        }


    }

    .filelist {
        height: 232px;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
        &::-webkit-scrollbar-thumb {
            background: rgba(144, 147, 153, 0.3);
            cursor: pointer;
            border-radius: 4px;
        }

        .fitem:hover {
            i {
                display: block;
                font-size: 20px;
                cursor: pointer;

                &:hover {
                    color: #409EFF;
                }
            }
        }

        .fitem {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;

            i {
                display: none;
                font-size: 20px;
                cursor: pointer;

                &:hover {
                    color: #409EFF;
                }
            }

            .fflex {
                display: flex;
                align-items: center;

                .fimg1 {
                    margin-right: 6px;
                    width: 50px;
                    height: 50px;
                    background: #E5FCFF;
                    border-radius: 4px 4px 4px 4px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .img {
                        width: 35px;
                        height: 35px;

                    }
                }

                .fimg {
                    margin-right: 6px;

                    .img {

                        width: 50px;
                        height: 50px;
                        border-radius: 4px 4px 4px 4px;
                    }
                }

                .fcont {
                    .warp {
                        flex: 1;

                        width: 285px;
                        /* 需要固定展示高度 且行高应与展示高度一致 */
                        line-height: 30px;
                        height: 30px;
                        /* 仅展示一行 */
                        overflow: hidden;
                        /* 重要 必须设置背景色 以在文字溢出换行时将原文字覆盖 */
                        background-color: #fff;
                        outline: none;
                        resize: none;
                    }

                    .content {
                        max-height: 30px;
                    }

                    .overflow {
                        display: block;
                        position: relative;
                        /* 重要 重新设置背景色将原文字覆盖 */
                        background: inherit;
                        top: -30px;
                        height: 30px;
                        overflow: hidden;
                        text-align: justify;
                    }

                    .overflow::before {
                        content: attr(data);
                        width: 50%;
                        float: right;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        direction: rtl;
                    }

                    .f1 {
                        width: 255px;
                        display: flex;
                        align-items: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                        line-height: 26px;
                    }

                    .f2 {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #ADAAAA;
                    }
                }
            }
        }
    }

    .btns {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        padding: 0 20px;

        .btn1 {
            width: 134px;
            height: 46px;
            background: #FFFFFF;
            border-radius: 5px 5px 5px 5px;
            border: 1px solid #DEDEDE;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 46px;
            text-align: center;
            cursor: pointer;
        }

        .btn2 {
            text-align: center;
            width: 134px;
            height: 46px;
            background: #FFDB0C;
            border-radius: 5px 5px 5px 5px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 46px;
            cursor: pointer;
        }
    }
}

.tim_cont {
    width: 780px;
    display: flex;
    justify-content: space-between;
    height: 100%;

    .tim_cont_l {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .tim_cont_top {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
            box-sizing: border-box;

            .c_flex {
                display: flex;
                align-items: center;

                .uname {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                    margin-right: 10px;
                }

                img {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .cs {
                font-size: 20px;
                cursor: pointer;
            }
        }

        .tim_cont_c {
            height: 420px;
            overflow-y: auto;
            background: #F7F8FA;
            box-sizing: border-box;
            border-top: 1px solid #eee;
            border-bottom: 1px solid #eee;

            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(144, 147, 153, 0.3);
                cursor: pointer;
                border-radius: 4px;
            }

            .icons {
                border: 1px solid red;
                margin-top: 100px;
            }

            .tim_time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #ADAAAA;
                text-align: center;
            }
            
            .tim_system {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 13px;
                color: #f05151;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .tim_revoketip {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 13px;
                color: #6b6a6a;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .left_cont_i {
                margin: 16px;
                display: flex;
            }

            .recall-btn {
                color: #999;
                font-size: 12px;
                margin-left: 8px;
                cursor: pointer;
                transition: color 0.3s;
                min-width: 30px;
            }

            .recall-btn:hover {
                color: #409EFF;
                text-decoration: underline;
            }

            .avatar {
                width: 40px;
                height: 40px;
                border-radius: 6px;
            }

            .right_cont_i {
                margin: 16px;
                text-align: right;
            }

            .isread {
                font-size: 12px;
                position: absolute;
                bottom: 0%;
                left: -30px;
                color: #ADAAAA !important;
            }

            .preview-file-btn {
                width: 60px;
                height: 28px;
                padding: 0;
                font-size: 10px;
                font-weight: 600;
                border: 1px solid #409EFF; /* 细边框 */
                border-radius: 3px;
                background: rgba(64, 158, 255, 0.12);
                color: #409EFF;
                cursor: pointer;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                box-sizing: border-box; /* 确保尺寸精确 */
                line-height: 18px; /* 垂直居中 */
                letter-spacing: 0.3px;
                margin-left: 10px;
                margin-bottom: 20px;
            }

            /* 悬停状态 */
            .preview-file-btn:hover {
                background: rgba(64, 158, 255, 0.2);
                box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
                transform: translateY(-1px);
            }

            /* 点击状态 */
            .preview-file-btn:active {
                transform: translateY(1px);
                background: rgba(64, 158, 255, 0.3);
            }

            /* 禁用状态 */
            .preview-file-btn:disabled {
                border-color: #C0C4CC;
                background: #F5F7FA;
                color: #C0C4CC;
                cursor: not-allowed;
                box-shadow: none;
                transform: none;
            }

            /* 禁用状态下的hover */
            .preview-file-btn:disabled:hover {
                background: #F5F7FA;
            }

            .cobule {
                color: rgb(78, 78, 255) !important;
            }

            .rig {
                display: flex;
                flex-direction: row-reverse;
                position: relative;
            }

            .xx {
                max-width: 60%;
                background-color: #fff;
                border-radius: 4px;
                align-items: center;
                text-align: left;
                padding: 10px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 22px;
                position: relative;
                white-space: pre-wrap;
                display: flex;
            }

            .img {
                max-width: 60%;
                border-radius: 4px;
                align-items: center;
                text-align: left;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 22px;
                position: relative;
            }

            .file {
                max-width: 60%;
                padding: 10px;
                background-color: #fff;
                border-radius: 4px;
                align-items: center;
                text-align: left;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                position: relative;

                .file_flex {
                    display: flex;
                    align-items: center;
                }

                .imgs {
                    width: 40px;
                    height: 40px;
                    background: #E5FCFF;
                    border-radius: 5px 5px 5px 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;

                    img {
                        width: 30px;
                        height: 36px;
                    }
                }

                .imgsd {
                    width: 34px;
                    height: 34px;
                    margin-left: 20px;
                    cursor: pointer;
                }

                .filename {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                }

                .filesize {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #ADAAAA;
                }
            }

            .xx::before {
                content: '';
                position: absolute;
                left: -5px;
                width: 8px;
                height: 8px;
                transform: rotate(45deg);
                background-color: #fff;
            }

            .rig>.xx::before {
                left: unset;
                right: -5px;
            }
        }

        .right_bot {
            width: 100%;
            height: 220px;
            position: relative;
            padding: 10px 20px;
            box-sizing: border-box;

            .send_flex {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .flex_l {
                    display: flex;
                    align-items: center;
                }

                img {
                    widows: 24px;
                    height: 24px;
                    margin-right: 6px;
                }

                .its {
                    display: flex;
                    align-items: center;
                    margin-right: 10px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                }

                .btns {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                }
            }

            ::v-deep .el-textarea .el-textarea__inner {
                font-family: PingFang SC, PingFang SC;
                width: 100%;
                height: 120px;
                font-size: 14px;
                padding: 10px 0px;
                box-sizing: border-box;
                border: none;
                outline: none;
                resize: none;

                &::-webkit-scrollbar {
                    width: 4px;
                    height: 4px;
                }

                // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
                &::-webkit-scrollbar-thumb {
                    background: rgba(144, 147, 153, 0.3);
                    cursor: pointer;
                    border-radius: 4px;
                }
            }

            .btn {
                position: absolute;
                bottom: 20px;
                right: 20px;
                font-size: 14px;
                border-radius: 8px;
                cursor: pointer;
                background: #FFDB0C;
                width: 80px;
                height: 40px;
                border-radius: 5px 5px 5px 5px;
                text-align: center;
                line-height: 40px;
                color: #000000;
            }

        }
    }

    .tim_cont_r {
        min-width: 278px;
        border-left: 1px solid #eee;
        transition: .5s ease;

        .tit {
            min-width: 278px;
            height: 50px;
            line-height: 50px;
            padding: 0px 10px;
            box-sizing: border-box;
            border-bottom: 1px solid #eee;

        }

        .orderlist {
            height: 650px;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 4px;
                height: 4px;
            }

            // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
            &::-webkit-scrollbar-thumb {
                background: rgba(144, 147, 153, 0.3);
                cursor: pointer;
                border-radius: 4px;
            }

            .items {
                padding: 12px 10px;
                box-sizing: border-box;

                .itime {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #ADAAAA;
                    margin-bottom: 6px;
                }

                .item_flex {
                    display: flex;

                    img {
                        width: 36px;
                        height: 36px;
                    }

                    .uflex {
                        flex: 1;
                        margin-left: 6px;

                        .cflex {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 3px;
                        }

                        .r1 {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 500;
                            font-size: 14px;
                            color: #000000;
                        }

                        .r2 {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 500;
                            font-size: 12px;
                            color: #ADAAAA;
                        }
                    }

                    .price {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                    }
                }
            }
        }
    }
}

.khxx {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    align-items: flex-start; /* 左对齐 */
    min-height: 60px; /* 固定一个最小高度 */

    .khxx-item {
        display: flex; /* 使用 flex 布局 */
        align-items: top; /* 垂直居中 */
        max-width: 400px; /* 最大宽度限制 */
        text-align: left; /* 文本左对齐 */
        word-wrap: break-word; /* 自动换行 */
        white-space: normal; /* 允许换行 */
        margin-bottom: 8px; /* 增加间距，避免内容过于紧凑 */
        margin-top: 8px;
    }

    .khxx-icon {
        width: 16px; /* 图标宽度 */
        height: 16px; /* 图标高度 */
        margin-right: 8px; /* 图标与文本的间距 */
    }
    .khxx-close-btn {
        position: absolute; /* 绝对定位 */
        top: 2px; /* 距离顶部 */
        right: 4px; /* 距离右侧 */
        background: none; /* 去掉背景 */
        border: none; /* 去掉边框 */
        font-size: 18px; /* 关闭按钮大小 */
        color: #999; /* 关闭按钮颜色 */
        cursor: pointer; /* 鼠标悬停时显示手型 */
        padding: 0; /* 去掉内边距 */
    }

    .khxx-close-btn:hover {
        color: #333; /* 鼠标悬停时颜色变深 */
    }
}

</style>